import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import ValidationsBuilder from './collection/derived-validation/ValidationsBuilder';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { VALIDATION } from 'drapcode-constant';
export class Validations extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
  }

  render() {
    const { collections, common, match, actions, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionDetailPending,
      selectedCollection,
      deleteCollectionValidationPending,
      permissionFlags,
    } = collections;
    const { updatedCollections } = common;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <CommonPageComponent parentClassName="">
        <CollectionHeaderNav
          label={types.VALIDATION}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionDetailPending && (
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionDetailPending}
              size="20px"
              color="#303453"
            />
          </div>
        )}
        {selectedCollection && (
          <ValidationsBuilder
            actions={actions}
            commonActions={commonActions}
            version={version}
            projectId={projectId}
            validations={selectedCollection.validations}
            collection={selectedCollection}
            collections={collections}
            showValidationDeleteLoader={deleteCollectionValidationPending}
            flag={permissionsArray.includes(VALIDATION)}
            updatedCollections={updatedCollections}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Validations);
